import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  select: {
    minWidth: 200
  },
  code: {
    display: 'none',

    '@media print': {
      display: 'block'
    }
  }
}))
